import { render, staticRenderFns } from "./acceptResultsList.vue?vue&type=template&id=3b568bf5&scoped=true"
import script from "./acceptResultsList.vue?vue&type=script&lang=js"
export * from "./acceptResultsList.vue?vue&type=script&lang=js"
import style0 from "./acceptResultsList.vue?vue&type=style&index=0&id=3b568bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b568bf5",
  null
  
)

export default component.exports